<div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-icon-warning swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
  <div class="swal2-header">
    <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
      <div class="swal2-icon-content">!</div>
    </div>
    <img class="swal2-image" style="display: none;">
    <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@AreYouSureHeader">Sind Sie sicher?</h2>
    <button type="button" id="close" class="swal2-close" aria-label="Close this dialog" style="display: none;">×</button>
  </div>
  <div class="swal2-content">
    <div id="swal2-content" class="swal2-html-container" style="display: block;" i18n="@@DeleteOfAssignmentCannotBeUndoneWarning">Das Löschen der Zuordnung kann nicht rückgängig gemacht werden!</div>
  </div>
  <div class="swal2-actions">
    <div class="swal2-loader"></div>
    <button type="button" id="confirm_delete" class="btn btn-danger me-2" aria-label="" (click)="onConfirmClick()" i18n="@@DeleteAssigmentButton">Zuordnung löschen</button>
    <button type="button" id="cancel" class="btn btn-yellow" aria-label="" (click)="onCancelClick()" i18n="@@CancelButton">Abbrechen</button>
  </div>
</div>
